import React, { useContext } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import { ThemeContext } from 'styled-components';

const ButtonList = React.forwardRef(({
    children,
    onClick,
    baseOpacity = 0.85,
    hoverOpacity = 1,
    pressedOpacity = 0.5,
    minHeight = 48,
    justifyContent,
    px = 2.5,
    ...props
}, ref) => {
    const theme = useContext(ThemeContext);

    return (
        <ListItemButton
            ref={ref}
            onClick={onClick}
            disableRipple
            {...props}
            sx={{
                minHeight,
                justifyContent,
                px,
                opacity: baseOpacity,
                backgroundColor: 'transparent !important',
                transition: 'opacity 120ms ease, background-color 0ms !important',
                '&:hover': {
                    opacity: hoverOpacity,
                    backgroundColor: 'transparent !important',
                    '& .MuiListItemIcon-root > *': {
                        transform: 'translate(-0.5px, -0.5px)',
                        transition: 'transform 120ms ease',
                        textShadow: theme.textShadow,
                    },
                    '& .MuiListItemText-primary': {
                        fontWeight: 900,
                        transform: 'translate(-0.5px, -0.5px)',
                        transition: 'font-weight 120ms ease, transform 120ms ease, text-shadow 120ms ease',
                        textShadow: theme.textShadow,
                    },
                },
                '&:active': {
                    opacity: pressedOpacity,
                    backgroundColor: 'transparent !important',
                    '& .MuiListItemIcon-root > *': {
                        transform: 'none',
                        textShadow: 'none',
                    },
                    '& .MuiListItemText-primary': {
                        fontWeight: 850,
                        transform: 'none',
                        textShadow: 'none',
                    },
                },
                '&:focus, &.Mui-focusVisible': {
                    outline: 'none',
                    backgroundColor: 'transparent !important',
                },
                '& .MuiTouchRipple-root': {
                    display: 'none !important',
                },
                ...props.sx,
            }}
        >
            {children}
        </ListItemButton>
    );
});

export default ButtonList;
